export default __webpack_public_path__ + "static/media/susie1.c75dc338.jpg";